/* jshint ignore:start */

var ProgressManager = (function ($) {
    var instance;

    function init() {

        function iniciandoProgressBar() {            
            // PROGRESS BAR
            var offsetTop = $('#progressnumber').offset().top;

            console.log('offsetTop', offsetTop);

            $(window).scroll(function() {
                var height = $(window).height();
                if($(window).scrollTop()+height > offsetTop) {
                    jQuery('.progressnumber__center-container').each(function(){
                        jQuery(this).find('.progressnumber__bar').animate({
                            width:jQuery(this).attr('data-percent')
                        },3000);
                    });
                }
            });
        
            // PROGRESS NUMBER

            var a = 0;
            $(window).scroll(function () {
                var oTop = $(".counter-box").offset().top - window.innerHeight;
                if (a == 0 && $(window).scrollTop() > oTop) {
                    $(".counter").each(function () {
                        var $this = $(this),
                            countTo = $this.attr("data-number");
                        $({
                            countNum: $this.text()
                        }).animate(
                            {
                                countNum: countTo
                            },

                            {
                                duration: 2500,
                                easing: "swing",
                                step: function () {
                                    $this.text(
                                        Math.ceil(this.countNum).toLocaleString("es")
                                    );
                                },
                                complete: function () {
                                    $this.text(
                                        Math.ceil(this.countNum).toLocaleString("es")
                                    );
                                }
                            }
                        );
                    });
                    a = 1;
                }
            });

        }

        function iniciandoTimeline() {
            var items = $(".timeline li"),
            timelineHeight = $(".timeline ul").height(),
            greyLine = $('.default-line'),
            lineToDraw = $('.draw-line');


            if(lineToDraw.length) {
                $(window).on('scroll', function () {

                    var redLineHeight = lineToDraw.height(),
                    greyLineHeight = greyLine.height(),
                    windowDistance = $(window).scrollTop(),
                    windowHeight = $(window).height() / 2,
                    timelineDistance = $(".timeline").offset().top;

                    if(windowDistance >= timelineDistance - windowHeight) {
                    line = windowDistance - timelineDistance + windowHeight;

                    if(line <= greyLineHeight) {
                        lineToDraw.css({
                        'height' : line + 20 + 'px'
                        });
                    }
                    }

                    var bottom = lineToDraw.offset().top + lineToDraw.outerHeight(true);
                    items.each(function(index){
                    var circlePosition = $(this).offset();

                    if(bottom > circlePosition.top) {				
                        $(this).addClass('in-view');
                    } else {
                        $(this).removeClass('in-view');
                    }
                    });	
                });
            }

                   
        }

        function iniciandoAccordion() {
            console.log('MAQUETA WEB....... iniciandoAccordion');

            $('.js-module-accordeon').each(function () {
                var $content = $(this);
                $content.find(".js-accordeon-item-btn").click(function(e) {
                    e.preventDefault();

                    $content.find('.js-accordeon-item').removeClass('active');
                    $(this).closest('.js-accordeon-item').addClass('active');

                    var offset = 200;
                    var delay = 500;
                    var $this = $(this);
                    if ($this.next().hasClass("showing")) {
                      $this
                        .next()
                        .removeClass("showing")
                        .slideUp(delay);
                    } else {
                      $this
                        .parent()
                        .parent()
                        .find("li .accordion__element-content")
                        .removeClass("showing")
                        .slideUp(delay);
                        
                      $this
                        .next()
                        .toggleClass("showing")
                        .slideToggle(delay, function() {
                          $("html,body").animate(
                            {
                              scrollTop: $(this).parent().find("a").offset().top - offset
                            },
                            delay
                          );
                        });
                    }
                });   

            });

            

            
         
        } 


        return {

            init: function () {

                var $itemsProgress = $('.js-progress-module');
                if ($itemsProgress.length) {
                    iniciandoProgressBar();
                }

                var $itemsTimeline = $('.js-module-timeline');
                if ($itemsTimeline.length) {
                    iniciandoTimeline();
                }

                var $itemsAccordeon = $('.js-module-accordeon');
                if ($itemsAccordeon.length) {
                    iniciandoAccordion();
                }
            }
        };
    }


    return {

        getInstance: function () {

            if (!instance) {
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */

